import React, { DragEventHandler } from 'react'
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined'
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined'
import { styled } from '@mui/material'

import { useFileDrop } from 'elements/FileUpload/common/useFileDrop'

import { UploadWrapperProps } from '../common/commonInterfaces'

const UploadWrapperStyled = styled('label')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 118,
  marginBottom: 4,
  padding: 16,
  borderRadius: 12,
  border: `1px dashed ${theme.palette.text.secondary}`,
  textAlign: 'center',
  cursor: 'pointer',
  '& > svg:first-of-type': {
    marginBottom: '8px',
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '& p': {
    margin: '0 auto',
    textAlign: 'center',
    fontSize: '0.875rem',
    '& span': {
      display: 'block',
      marginTop: '8px',
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
  },
}))

export default function UploadWrapper({
  name,
  onChange,
  withImage,
}: UploadWrapperProps): JSX.Element {
  const onDrop: DragEventHandler<HTMLLabelElement> = (event) => {
    if (event.dataTransfer?.files == null) {
      return
    }

    onChange(event.dataTransfer.files)
  }

  const dragHandlers = useFileDrop(onDrop)

  return (
    <UploadWrapperStyled className="drag-area" htmlFor={name} {...dragHandlers}>
      {withImage! ? <AddPhotoAlternateOutlinedIcon /> : <NoteAddOutlinedIcon />}
      <p>
        Drag {withImage! ? 'photos' : 'files'} here to upload
        <br />
        <span>Add from computer</span>
      </p>
    </UploadWrapperStyled>
  )
}
